module.exports = __webpack_public_path__ + "img/img-17.a1fab877.png";